export default function trimMiddle(str) {
    if (str.length <= 10) {
        return str; // Если строка слишком короткая, возвращаем её без изменений
    }
    const start = str.slice(0, 5); // Первые 5 символов
    const end = str.slice(-5); // Последние 5 символов
    return start + '...' + end; // Соединяем их с "..."
}
